<template>
  <div class="verval">
    <!--daftar-->
    <v-card tile flat class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5">
            <h1 class="headline black--text--text">
              Verval Kelas Diklat {{ $titleCase(akses === 'refreshment' ? 'PPM & PPTM' : akses) }}
            </h1>
            <div> </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-text>
        <base-table-header
          btn-filter
          :btnDownload="$allow(`${this.jenis}-verval.download`) || $allow(`${this.jenis}-kelas-luring`)"
          @download="onDownload"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              <b>{{ total }}</b> Ajuan Verval
            </div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-filter
          ref="filter"
          title="Pilih Filter Status"
          :filtered="filtered"
          :filters="formFilter"
          :paramsFilter="filters"
          @save="filterSave"
        />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0" @click="onVerval(item)">
                        <v-list-item-icon class="mr-2 my-auto">
                          <v-icon color="primary" size="60">mdi-google-classroom</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="py-0 px-1">
                          <p class="caption"> Nama Kelas </p>
                          <span class="body-1 black--text">
                            {{ $getAttr(item, `nama`) || '-' }}
                          </span>
                          <div class="font-italic">
                            {{
                              $getAttr(
                                $getIncluded(
                                  `instansi`,
                                  $getAttr(
                                    $getIncluded(`paud_diklat${label}`, $getAttr(item, `paud_diklat${label}_id`)),
                                    'instansi_id'
                                  )
                                ),
                                'nama'
                              )
                            }}
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <div class="label--text">Tanggal Pelaksanaan</div>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            <div v-if="akses === 'daring'">
                              {{
                                $durasi(
                                  $getAttr(
                                    $getIncluded(
                                      `paud_periode`,
                                      $getAttr(
                                        $getIncluded('paud_diklat', $getAttr(item, 'paud_diklat_id')),
                                        'paud_periode_id'
                                      )
                                    ),
                                    'tgl_diklat_mulai'
                                  ),
                                  $getAttr(
                                    $getIncluded(
                                      `paud_periode`,
                                      $getAttr(
                                        $getIncluded('paud_diklat', $getAttr(item, 'paud_diklat_id')),
                                        'paud_periode_id'
                                      )
                                    ),
                                    'tgl_diklat_selesai'
                                  )
                                )
                              }}
                            </div>
                            <div v-else>
                              {{
                                $durasi(
                                  $getAttr(
                                    $getIncluded(`paud_diklat${label}`, $getAttr(item, `paud_diklat${label}_id`)),
                                    'tgl_mulai'
                                  ),
                                  $getAttr(
                                    $getIncluded(`paud_diklat${label}`, $getAttr(item, `paud_diklat${label}_id`)),
                                    'tgl_selesai'
                                  )
                                )
                              }}
                            </div>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <div class="label--text">Jenis Diklat</div>
                          </v-list-item-title>
                          <div class="link black--text body-2">
                            <template v-if="['refreshment'].includes(akses)">
                              {{
                                $getAttr(
                                  $getIncluded(
                                    'm_diklat_bimtek_paud',
                                    $getAttr(
                                      $getIncluded(`paud_diklat${label}`, $getAttr(item, `paud_diklat${label}_id`)),
                                      'k_diklat_bimtek_paud'
                                    )
                                  ),
                                  'keterangan'
                                )
                              }}
                            </template>
                            <template v-else>
                              {{
                                M_DIKLAT_PAUD[
                                  $getAttr(
                                    $getIncluded(`paud_diklat${label}`, $getAttr(item, `paud_diklat${label}_id`)),
                                    'k_diklat_paud'
                                  )
                                ]
                              }}
                            </template>
                          </div>
                          <v-list-item-title class="mt-2">
                            <div class="label--text">Jenjang Diklat</div>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            {{
                              M_JENJANG_DIKLAT_PAUD[
                                $getAttr(
                                  $getIncluded(`paud_diklat${label}`, $getAttr(item, `paud_diklat${label}_id`)),
                                  'k_jenjang_diklat_paud'
                                )
                              ]
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <div class="label--text">Status</div>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-chip :color="getColor($getAttr(item, 'k_verval_paud'))" dark small>
                              {{
                                $getAttr($getIncluded('m_verval_paud', $getAttr(item, 'k_verval_paud')), 'keterangan')
                              }}
                            </v-chip>
                            <template v-if="[4, 5].includes(Number($getAttr(item, 'k_verval_paud')))">
                              <v-btn class="ml-1" rounded outlined x-small color="orange" @click="onCatatan(item)">
                                <v-icon left>mdi-file-edit</v-icon> Catatan
                              </v-btn>
                            </template>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            v-if="[6].includes(Number($getAttr(item, 'k_verval_paud'))) && akses === 'daring'"
                            class="link black--text body-2"
                          >
                            <span :class="$getAttr(item, 'wkt_sync') ? 'success--text caption' : 'red--text caption'">
                              {{ $getAttr(item, 'wkt_sync') ? 'Sudah Sinkronisasi' : 'Belum Sinkronisasi' }}
                              <v-tooltip v-if="!$getAttr(item, 'wkt_sync')" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon small color="warning" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                                </template>
                                <span>Silakan melakukan aksi sinkronisasi</span>
                              </v-tooltip>
                            </span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <div
                              v-if="
                                isAksi.includes(Number($getAttr(item, 'k_verval_paud'))) &&
                                $allow('kelas-verval.update-verval')
                              "
                              class="label--text"
                              >Aksi Selanjutnya</div
                            >
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn
                              v-if="
                                [2].includes(Number($getAttr(item, 'k_verval_paud'))) &&
                                $allow('kelas-verval.update-verval')
                              "
                              color="primary"
                              small
                              @click="onVerval(item)"
                            >
                              Verval Ajuan
                            </v-btn>
                            <v-btn
                              v-if="
                                [6].includes(Number($getAttr(item, 'k_verval_paud'))) &&
                                akses === 'daring' &&
                                $allow('kelas-verval.sync-kelas')
                              "
                              color="success"
                              small
                              @click="onSync(item)"
                              :disabled="!!isEndDiklat(item)"
                            >
                              Sinkronisasi
                            </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col v-if="catatans[item.id]" cols="12" sm="12" md="12" class="px-0 pb-0">
                      <v-alert text color="orange" class="ml-3">
                        <div class="black--text body-2">
                          <b>Catatan:</b> <br />
                          {{ $getAttr(item, 'alasan') }}
                        </div>
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      colorBtn="primary"
      :title="formulir['title']"
      :autoClose="formulir['autoClose']"
      :useSave="formulir['is_edit']"
      fluid
      @close="onClose"
      @save="onSave"
    >
      <form-verval
        ref="formulir"
        :masters="Object.assign({}, masters)"
        :id="formulir['id']"
        :detail="formulir['detail']"
        :berkas="formulir['berkas']"
        :fungsi="formulir['fungsi']"
        :isEdit="formulir['is_edit']"
        :isDisable="formulir['is_disable']"
        :initValue="formulir['init']"
        :jenis="jenis"
        :obj="obj"
        :akses="akses"
      ></form-verval>
    </base-modal-full>
  </div>
</template>

<script>
import actions from './actions';
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import FormVerval from '../../formulir/Verval';
export default {
  name: 'Index',
  mixins: [list],
  data() {
    return {
      formulir: {},
      listTimVerval: [],
      listLaporan: [],
      included: [],
      actions: actions,
      mPeriode: {},
      M_DIKLAT_PAUD: {
        1: 'Diklat Berjenjang',
        2: 'Diklat PCP',
        3: 'Diklat MOT',
        4: 'Diklat Lainnya',
      },
      M_DIKLAT_REFRESHMENT: {
        1: 'BIMTEK_PPM	Bimtek Penyegaran Pengajar Pendalaman Materi',
        2: 'BIMTEK_PPTM	Bimtek Pembekalan Pembimbing Praktik Tugas Mandiri',
      },
      M_JENJANG_DIKLAT_PAUD: {
        1: 'Dasar',
        2: 'Lanjut',
        3: 'Mahir',
      },
      M_LABEL: {
        daring: '',
        luring: '_luring',
        refreshment: '_bimtek',
      },
      catatans: {},
    };
  },
  components: { FormVerval },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => (state.data && state.data.akun) || {},
    }),

    isAksi() {
      if (this.akses === 'daring') {
        return this.$allow('kelas-verval.sync-kelas') ? [2, 6] : [6];
      } else {
        return [2];
      }
    },

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    mapTimVerval() {
      let temp = {};
      for (const akun of this.listTimVerval) {
        temp[this.$getDeepObj(akun, 'akun.data.akun_id')] = this.$getDeepObj(akun, 'akun.data.nama');
      }
      return temp;
    },

    mapStatusVerval() {
      const masters = (this.masters && this.masters.m_verval_paud) || {};
      let temp = {};

      Object.keys(masters).forEach((item) => {
        if (![1, 3].includes(Number(item))) {
          this.$set(temp, item, masters[item]);
        }
      });

      return temp;
    },

    formFilter() {
      let temp = [
        {
          label: 'Pilih Status Verval',
          default: true,
          type: 'checkbox',
          model: 'k_verval_paud',
          master: this.$mapForMaster(this.mapStatusVerval),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12, md: this.akses === 'daring' ? 6 : 12 },
        },
      ];

      if (this.akses === 'daring') {
        temp.push({
          label: 'Periode Diklat',
          type: 'select',
          model: 'paud_periode_id',
          master: this.$mapForMaster(this.mPeriode),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
      }

      if (['daring', 'luring'].includes(this.akses)) {
        temp.push({
          label: 'Jenis Diklat',
          default: true,
          type: 'select',
          model: 'k_diklat_paud',
          master: this.$mapForMaster(this.M_DIKLAT_PAUD).filter((s) => Number(s.value) < 4),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
        temp.push({
          label: 'Jenjang Diklat',
          default: true,
          type: 'select',
          model: 'k_jenjang_diklat_paud',
          master: this.$mapForMaster(this.M_JENJANG_DIKLAT_PAUD),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
      }

      return temp;
    },

    filtersMaster() {
      return {
        k_verval_paud: this.mapStatusVerval,
        paud_periode_id: this.mPeriode,
        k_diklat_paud: this.M_DIKLAT_PAUD,
        k_jenjang_diklat_paud: this.M_JENJANG_DIKLAT_PAUD,
      };
    },

    obj() {
      return this.$route.meta.atribut;
    },

    keyTipe() {
      return this.$route.meta.paudkey;
    },

    jenis() {
      return (this.$route.meta && this.$route.meta.tipe) || 'kelas';
    },

    akses() {
      return (this.$route.meta && this.$route.meta.akses) || 'daring';
    },

    label() {
      return this.M_LABEL[this.akses];
    },
  },
  mounted() {
    Object.assign(this.attr, { type: this.akses });
  },
  created() {
    this.getMasters({
      name: ['m_verval_paud'].join(';'),
    });
    this.getPeriode({}).then(({ data }) => {
      this.mPeriode = {};
      const items = data || [];

      items.forEach((item) => {
        this.$set(this.mPeriode, item.id, item.nama);
      });
    });
  },
  methods: {
    ...mapActions('diklatVerval', [
      'fetch',
      'getDetail',
      'action',
      'downloadList',
      'getKinerja',
      'getTimVerval',
      'getPeriode',
    ]),
    ...mapActions('master', ['getMasters']),

    fetchData: function () {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? { filter: this.filters } : {});
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then(({ data, meta, included }) => {
          this.data = data || [];
          this.included = included || [];
          this.total = meta?.total || data.length || 0;
          this.pageTotal = meta?.last_page || 1;
          resolve(true);
        });
      });
    },

    allowMenu(data) {
      const akses = this.actions;
      let status = false;

      akses.forEach((item) => {
        if (this.allow(item, data)) {
          status = true;
          return;
        }
      });
      return status;
    },

    allow(action, data) {
      let allow = false;
      const kVerval = this.getKVerval(data);
      switch (action.event) {
        case 'onBatalVerval':
          allow =
            this.$allow(action.akses) &&
            Number(kVerval) > 3 &&
            [1, null, undefined].includes(this.$getAttr(data, 'laporan_k_verval_paud'));
          break;
        default:
          allow = this.$allow(action.akses);
          break;
      }
      return allow;
    },

    allowVerval(item) {
      const kVerval = this.getKVerval(item);
      return this.$allow('kelas-verval.update-verval') && kVerval <= 3;
    },

    getKVerval(item) {
      return Number(this.$getAttr(item, 'k_verval_paud'));
    },

    getAkunVerval(item) {
      return this.jenis === 'petugas'
        ? this.$getDeepObj(item, 'paud_petugas_perans.data.0.akun_verval')
        : this.$getDeepObj(item, 'akun_verval');
    },

    getAkunIdVerval(item) {
      return this.jenis === 'petugas'
        ? Number(this.$getDeepObj(item, 'paud_petugas_perans.data.0.akun_id_verval'))
        : Number(this.$getDeepObj(item, 'akun_id_verval'));
    },

    onClose() {
      if (!this.formulir['autoClose']) {
        const msg = [
          '<h3>Apakah Anda yakin ingin keluar dari halaman Verifikasi Ajuan Kelas ?</h3>',
          'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini',
        ].join(' ');
        this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
          this.$refs.modal.dialog = false;
        });
      }
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(this.$getDeepObj(item, 'no_wa'))}`;
      window.open(url, '_blank');
    },

    isAllowAkses(policies) {
      let enable = false;
      let akses = ['psp-peserta-berkas.setuju', 'psp-peserta-berkas.tolak', 'psp-peserta-berkas.tolak-revisi'];

      akses.forEach((key) => {
        if (this.$allow(key, policies)) {
          enable = true;
          return;
        }
      });

      return enable;
    },

    async onVerval(item) {
      const kVerval = this.$getAttr(item, 'k_verval_paud');
      const status = {
        color: this.getColor(kVerval),
        keterangan: this.$getAttr(
          this.$getIncluded('m_verval_paud', this.$getAttr(item, 'k_verval_paud')),
          'keterangan'
        ),
      };

      let init = {};

      init = {
        pilihan: kVerval <= 3 ? null : kVerval === 4 ? 1 : kVerval === 6 ? 2 : 3,
        catatan: this.$getAttr(item, 'alasan'),
      };

      this.$set(this.formulir, 'form', 'form-verval');
      this.$set(this.formulir, 'title', 'Verval Ajuan');
      this.$set(this.formulir, 'id', item.id);
      this.$set(this.formulir, 'init', null);

      this.getDetail({ id: item.id }).then(({ data }) => {
        this.$set(this.formulir, 'is_disable', !this.allowVerval(item));
        this.$set(this.formulir, 'is_edit', this.allowVerval(item));
        this.$set(this.formulir, 'autoClose', !this.allowVerval(item));

        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'init', init);
          this.$set(this.formulir, 'detail', data);
          this.$set(this.formulir.detail, 'status', status);
        });
      });
    },

    onSave() {
      const formulir = Object.assign({}, this.$refs.formulir.getValue());
      const status = formulir.pilihan;
      const alasan = formulir.alasan || '-';
      const id = formulir.id;

      if (status) {
        const aksi = status === 1 ? '4' : status === 2 ? '6' : '5';
        const html = `<span class="subtitle-1">Anda Yakin ingin <strong>${
          status === 1 ? 'menolak' : status === 2 ? 'menerima' : 'menyatakan perbaikan'
        }</strong> ajuan verval berikut ?</span>`;

        this.$confirm(html, 'Konfirmasi', { tipe: status === 1 ? 'error' : status === 2 ? 'success' : 'warning' }).then(
          () => {
            this.$refs.modal.loading = true;
            this.action({ id: id, params: { k_verval_paud: aksi, alasan }, type: 'verval' })
              .then(() => {
                this.$success('Ajuan berhasil di verifikasi');
                this.$refs.modal.dialog = false;
                this.onReload();
              })
              .catch(() => {
                this.$refs.modal.loading = false;
              });
          }
        );
        this.$refs.modal.loading = false;
      } else {
        this.$error('Silakan tentukan hasil verifikasi data sebelum simpan');
        this.$refs.modal.loading = false;
      }
    },

    onKunci(data) {
      this.id = data.id;
      this.$confirm(`Anda yakin ingin mengunci Ajuan di atas agar bisa diverifikasi?`, `Kunci Ajuan`, {
        tipe: 'warning',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: this.id, jenis: this.jenis, type: 'kunci', method: 'get' }).then(() => {
          this.$success(`Ajuan Peserta berhasil dikunci`);
          this.onReload();
        });
      });
    },

    onBatalKunci(data) {
      this.$confirm(`Anda yakin ingin membatalkan Kunci Verifikasi Ajuan Peserta di atas?`, `Batal Kunci Ajuan`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.id, jenis: this.jenis, type: 'batal-kunci', method: 'get' }).then(() => {
          this.$success(`Batal kunci Ajuan Peserta berhasil`);
          this.onReload();
        });
      });
    },

    onBatalVerval(data) {
      this.$confirm(`Anda yakin ingin membatalkan VerVal Ajuan di atas?`, `Batal Verval`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: data.id, type: 'batal-verval', method: 'post' }).then(() => {
          this.$success(`Batal Verval Ajuan Kelas Diklat berhasil`);
          this.onReload();
        });
      });
    },

    confirmHtml(data) {
      return [
        {
          icon: 'mdi-account-circle',
          iconSize: 50,
          iconColor: 'primary',
          title: `<b class='primary--text'>${
            this.$getAttr(this.$getIncluded('paud_mapel_kelas', this.$getAttr(data, 'paud_mapel_kelas_id')), 'nama') ||
            ''
          }</b>`,
          subtitles: [`<span class="text--primary">${this.$getAttr(data, `nama`)}</span>`],
        },
      ];
    },

    async onKinerja() {
      const params = {
        angkatan: this.params.angkatan,
        count: 100,
      };

      const resp = await this.getKinerja({ params });
      const nilais = (resp && resp.data) || [];
      const statistik = this.statistik || {};
      const limit = Number(this.$getDeepObj(resp, 'meta.total')) || 0;

      const items = nilais.map((key, index) => {
        return {
          no: index + 1,
          nama: key.nama,
          diproses: key.diproses,
          disetujui: key.disetujui,
          revisi: key.revisi,
          ditolak: key.ditolak,
          jumlah: Number(key.diproses) + Number(key.disetujui) + Number(key.revisi) + Number(key.ditolak),
        };
      });

      const headers = [
        {
          text: 'NO',
          align: 'start',
          sortable: false,
          value: 'no',
        },
        { text: 'Tim Verval', value: 'nama' },
        { text: 'Diproses', value: 'diproses' },
        { text: 'Disetujui', value: 'disetujui' },
        { text: 'Revisi', value: 'revisi' },
        { text: 'Ditolak', value: 'ditolak' },
        { text: 'Jumlah', value: 'jumlah' },
      ];

      this.$refs.kinerja.open();

      this.$nextTick(() => {
        this.$refs.formkinerja.reset();
        this.$refs.formkinerja.headers = headers;
        this.$refs.formkinerja.data = (resp && resp.nilais) || [];
        this.$refs.formkinerja.items = items || [];
        this.$refs.formkinerja.kinerja = (resp && resp.kinerja) || null;
        this.$refs.formkinerja.statistik = statistik;
        this.$refs.formkinerja.limit = limit;
      });
    },

    onDownload() {
      const M_LAPORAN = [
        {
          key: 'download',
          label: `Laporan Verval Kelas Diklat`,
          acl: `${this.jenis}-verval.download`,
        },
        {
          key: 'download-detil',
          label: `Laporan Detail Verval Kelas Diklat`,
          acl: `${this.jenis === 'kelas-luring'}`,
        },
      ];

      let url = {};
      this.$confirm('Pilih jenis Berkas yang ingin di Unduh?', 'Unduh Berkas', {
        tipe: 'secondary',
        form: {
          desc: 'Laporan Berkas',
          render: (h) => {
            return h(
              'select',
              {
                class: 'custom-select',
                domProps: {
                  value: '',
                },
                on: {
                  input: function (event) {
                    url.dokumen = event.target.value;
                  },
                },
              },
              [
                h('option', { attrs: { value: '' } }, '-- Pilih Jenis Unduhan --'),
                M_LAPORAN.filter((laporan) => this.$allow(laporan.acl)).map((item) =>
                  h('option', { attrs: { value: item.key } }, item.label)
                ),
              ]
            );
          },
        },
        lblConfirmButton: 'Unduh',
      }).then(() => {
        if (!url.dokumen) {
          this.$error('Silakan pilih laporan yang ingin diunduh!');
          return;
        }

        const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
        this.downloadList({ params, url: url.dokumen, jenis: this.jenis }).then((url) => {
          this.$downloadFile(url);
        });
      });
    },

    onUnduhKinerja() {
      const params = {};
      this.unduhKinerja(params).then((url) => {
        window.open(url, '_blank');
      });
    },

    onSync(data) {
      this.action({ id: data.id, params: {}, type: 'sync' })
        .then(() => {
          this.$success('Aksi berhasil dijalankan');
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    isEndDiklat(item) {
      const now = new Date();
      const wkt_selesai = this.$getAttr(
        this.$getIncluded(
          `paud_periode`,
          this.$getAttr(this.$getIncluded('paud_diklat', this.$getAttr(item, 'paud_diklat_id')), 'paud_periode_id')
        ),
        'tgl_diklat_selesai'
      );
      const wkt_penilaian = new Date(wkt_selesai);
      return now >= wkt_penilaian;
    },
    onCatatan(data) {
      const id = data['id'];
      if (this.catatans && this.catatans[id]) {
        this.$delete(this.catatans, id);
      } else {
        this.$set(this.catatans, id, true);
      }
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
